import { z } from 'zod';
import {
  ProductIntlSchema,
  productSchema,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/product.ts';
import { errorMessage } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import {
  MAX_PURCHASE_PER_USER__MAX,
  ProductType,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { LowStockVariantId } from '@services/MarppleShop/features/ProductMeta';

const dateSchema = z.union([z.date(), z.null()]).nullable().optional();
export const categoryCodeSchema = z.string({
  required_error: errorMessage.select_category,
  invalid_type_error: errorMessage.select_category,
});

export const storesProductBaseSchema = z.object({
  is_force_out_of_stock: z.boolean().default(false),
  sp_cate_root_code: categoryCodeSchema,
  sp_cate_list_code: categoryCodeSchema,
  sp_cate_item_code: categoryCodeSchema,
  product_type_id: z.nativeEnum(ProductType),
  membership_ids: z.array(z.string()).nullable(),
  max_purchase_per_user: z.number().int().max(MAX_PURCHASE_PER_USER__MAX).nullable(),
  sell_start_at: dateSchema,
  sell_end_at: dateSchema,
  meta: z.object({
    limited: z.boolean().default(false),
    low_stock_threshold: z.nativeEnum(LowStockVariantId).nullable().default(null),
    funding: z
      .object({
        target_amount: z.number(),
      })
      .nullable(),
  }),
  product_basic_info: z.string().optional(),
});

const CreatorProductBaseSchema = storesProductBaseSchema.extend({
  _: z.object({
    product: productSchema,
  }),
});

export const creatorProductSchema = CreatorProductBaseSchema;

export const creatorProductTplSchema = CreatorProductBaseSchema;

export const creatorProductTplIntlSchema = CreatorProductBaseSchema.extend({
  _: z.object({
    product: ProductIntlSchema,
  }),
});

export function getStoresProductSchema<T extends MODE>(
  mode: T,
): T extends typeof MODE.NEW | typeof MODE.EDIT
  ? typeof creatorProductSchema
  : T extends typeof MODE.EDIT_TPL
    ? typeof creatorProductTplSchema
    : T extends typeof MODE.EDIT_TPL_INTL
      ? typeof creatorProductTplIntlSchema
      : never;

export function getStoresProductSchema(
  mode: MODE,
): typeof creatorProductSchema | typeof creatorProductTplSchema | typeof creatorProductTplIntlSchema {
  switch (mode) {
    case MODE.NEW:
      return creatorProductSchema;
    case MODE.EDIT:
      return creatorProductSchema;
    case MODE.EDIT_TPL:
      return creatorProductTplSchema;
    case MODE.EDIT_TPL_INTL:
      return creatorProductTplIntlSchema;
    default:
      return creatorProductSchema;
  }
}
